/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The WalletControllerDtoNotificationSettingInfoResponse model module.
 * @module model/WalletControllerDtoNotificationSettingInfoResponse
 * @version 1.0
 */
class WalletControllerDtoNotificationSettingInfoResponse {
    /**
     * Constructs a new <code>WalletControllerDtoNotificationSettingInfoResponse</code>.
     * @alias module:model/WalletControllerDtoNotificationSettingInfoResponse
     */
    constructor() { 
        
        WalletControllerDtoNotificationSettingInfoResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>WalletControllerDtoNotificationSettingInfoResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WalletControllerDtoNotificationSettingInfoResponse} obj Optional instance to populate.
     * @return {module:model/WalletControllerDtoNotificationSettingInfoResponse} The populated <code>WalletControllerDtoNotificationSettingInfoResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WalletControllerDtoNotificationSettingInfoResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('perDailyMinimumAlarm')) {
                obj['perDailyMinimumAlarm'] = ApiClient.convertToType(data['perDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('perDailyMaximumAlarm')) {
                obj['perDailyMaximumAlarm'] = ApiClient.convertToType(data['perDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('perRealtimeMinimumAlarm')) {
                obj['perRealtimeMinimumAlarm'] = ApiClient.convertToType(data['perRealtimeMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperDailyMinimumAlarm')) {
                obj['xperDailyMinimumAlarm'] = ApiClient.convertToType(data['xperDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperDailyMaximumAlarm')) {
                obj['xperDailyMaximumAlarm'] = ApiClient.convertToType(data['xperDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperRealtimeMinimumAlarm')) {
                obj['xperRealtimeMinimumAlarm'] = ApiClient.convertToType(data['xperRealtimeMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhDailyMinimumAlarm')) {
                obj['hvhDailyMinimumAlarm'] = ApiClient.convertToType(data['hvhDailyMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhDailyMaximumAlarm')) {
                obj['hvhDailyMaximumAlarm'] = ApiClient.convertToType(data['hvhDailyMaximumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('hvhRealtimeMinimumAlarm')) {
                obj['hvhRealtimeMinimumAlarm'] = ApiClient.convertToType(data['hvhRealtimeMinimumAlarm'], 'Number');
            }
            if (data.hasOwnProperty('xperTransferLimit')) {
                obj['xperTransferLimit'] = ApiClient.convertToType(data['xperTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perTransferLimit')) {
                obj['perTransferLimit'] = ApiClient.convertToType(data['perTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('hvhMinimumWithdrawalBalance')) {
                obj['hvhMinimumWithdrawalBalance'] = ApiClient.convertToType(data['hvhMinimumWithdrawalBalance'], 'Number');
            }
            if (data.hasOwnProperty('hvhTransferAccount')) {
                obj['hvhTransferAccount'] = ApiClient.convertToType(data['hvhTransferAccount'], 'Number');
            }
            if (data.hasOwnProperty('xperUserOnetimeTransferLimit')) {
                obj['xperUserOnetimeTransferLimit'] = ApiClient.convertToType(data['xperUserOnetimeTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perUserOnetimeTransferLimit')) {
                obj['perUserOnetimeTransferLimit'] = ApiClient.convertToType(data['perUserOnetimeTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('xperUserDailtyTransferLimit')) {
                obj['xperUserDailtyTransferLimit'] = ApiClient.convertToType(data['xperUserDailtyTransferLimit'], 'Number');
            }
            if (data.hasOwnProperty('perUserDailtyTransferLimit')) {
                obj['perUserDailtyTransferLimit'] = ApiClient.convertToType(data['perUserDailtyTransferLimit'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WalletControllerDtoNotificationSettingInfoResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WalletControllerDtoNotificationSettingInfoResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} perDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} perDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} perRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perRealtimeMinimumAlarm'] = undefined;

/**
 * @member {Number} xperDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} xperDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} xperRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperRealtimeMinimumAlarm'] = undefined;

/**
 * @member {Number} hvhDailyMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['hvhDailyMinimumAlarm'] = undefined;

/**
 * @member {Number} hvhDailyMaximumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['hvhDailyMaximumAlarm'] = undefined;

/**
 * @member {Number} hvhRealtimeMinimumAlarm
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['hvhRealtimeMinimumAlarm'] = undefined;

/**
 * @member {Number} xperTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperTransferLimit'] = undefined;

/**
 * @member {Number} perTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perTransferLimit'] = undefined;

/**
 * @member {Number} hvhMinimumWithdrawalBalance
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['hvhMinimumWithdrawalBalance'] = undefined;

/**
 * @member {Number} hvhTransferAccount
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['hvhTransferAccount'] = undefined;

/**
 * @member {Number} xperUserOnetimeTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperUserOnetimeTransferLimit'] = undefined;

/**
 * @member {Number} perUserOnetimeTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perUserOnetimeTransferLimit'] = undefined;

/**
 * @member {Number} xperUserDailtyTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['xperUserDailtyTransferLimit'] = undefined;

/**
 * @member {Number} perUserDailtyTransferLimit
 */
WalletControllerDtoNotificationSettingInfoResponse.prototype['perUserDailtyTransferLimit'] = undefined;






export default WalletControllerDtoNotificationSettingInfoResponse;

